import React from 'react'
import { useIntl } from 'react-intl'
import { DataTable } from 'primereact/datatable'
import { SummaryFuelStationsService } from '../../../services/prices-fuel-stations/pricesFuelStations.service'
import useHandlerBasicActions from '../../../utils/hooks/useHandlerBasicActions'
import MainCommonView from '../../../components/common/MainCommonView'
import SummaryDataTable from '../../../components/fuel-stations/summary/SummaryDataTable'
import AppSection from '../../../component/layout/AppSection.tsx'
import AppTabMenu from '../../../component/layout/AppTabMenu.tsx'
import { fuelStationsMenu } from '../../../utils/constants/navlinks-Menu'

const Summary = () => {
  const { formatMessage: msg } = useIntl()

  const dataFacade = useHandlerBasicActions({
    getAll: SummaryFuelStationsService.getSummary,
    sortFieldInitial: 'centerName',
    sortInit: 1,
    rowsPerPageInitial: 100,
  })

  const headerOptions = {
    title: msg({ id: 'summary' }),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  return (
    <AppSection
      /* refactor this */
      header={<AppTabMenu options={fuelStationsMenu} />}
      headerOptions={headerOptions}
      dataFacade={dataFacade}
    >
      <SummaryDataTable
        value={dataFacade?.data?.resp}
        pagerOptions={pagerOptions}
      />
    </AppSection>
  )
}

export default Summary
